import React, { useEffect, useState } from "react";
import "./styles/ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    comment: "",
    company: "", // honeypot: left blank by real users
  });

  const [status, setStatus] = useState({ message: "", type: "", fade: false });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formRenderedAt] = useState(() => Date.now());

  useEffect(() => {
    if (!status.message) return;

    const t1 = setTimeout(() => setStatus((s) => ({ ...s, fade: true })), 2500);
    const t2 = setTimeout(
      () => setStatus({ message: "", type: "", fade: false }),
      4200
    );

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [status.message]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    setStatus({ message: "", type: "", fade: false });

    try {
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, formRenderedAt }),
      });

      if (!response.ok) throw new Error();

      setStatus({
        message: "Thanks for reaching out! We'll get back to you soon.",
        type: "success",
        fade: false,
      });

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        comment: "",
        company: "",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      setStatus({
        message: "Something went wrong. Please try again in a moment.",
        type: "error",
        fade: false,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-image-container">
      <div className="contact-container">
        <div className="contact-header">
          <h1>Get in Touch</h1>
        </div>

        {status.message && (
          <div
            className={`form-status ${status.type} ${status.fade ? "fade-out" : ""}`}
          >
            <span className="status-icon">
              {status.type === "success" ? "✓" : "⚠"}
            </span>
            {status.message}
          </div>
        )}

        <div className="contact-grid">
          {/* LEFT: FORM */}
          <div className="send-us-a-message-section">
            <div className="card-head">
              <h2>Send us a message</h2>
              <p className="helper-text">
                We typically respond within 1–2 business days.
              </p>
            </div>

            <form onSubmit={sendEmail} className="modern-form">
              <div className="honeypot-field" aria-hidden="true">
                <label htmlFor="company">Company</label>
                <input
                  id="company"
                  name="company"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-row">
                <div className="float-field">
                  <input
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>First name</label>
                </div>

                <div className="float-field">
                  <input
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>Last name</label>
                </div>
              </div>

              <div className="float-field">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder=" "
                  required
                />
                <label>Email address</label>
              </div>

              <div className="float-field">
                <textarea
                  name="comment"
                  rows={6}
                  value={formData.comment}
                  onChange={handleChange}
                  placeholder=" "
                  required
                />
                <label>Your message</label>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="primary-btn"
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner"></span>
                    Sending...
                  </>
                ) : (
                  "Send message"
                )}
              </button>

              <p className="fineprint">
                By submitting, you agree to be contacted about your request.
              </p>
            </form>
          </div>

          {/* RIGHT: INFO */}
          <div className="contact-side">
            <div className="side-card">
              <div className="side-card-top">
                <span className="side-icon">✉️</span>
                <h3>Email us</h3>
              </div>
              <a href="mailto:info@explorease.com" className="side-value">
                info@explorease.com
              </a>
            </div>

            <div className="side-card">
              <div className="side-card-top">
                <span className="side-icon">🕒</span>
                <h3>Support hours</h3>
              </div>
              <p className="side-value">Monday – Friday</p>
              <p className="side-subtext">9:00 AM – 5:00 PM EST</p>
            </div>

            <div className="side-card side-card-list">
              <div className="side-card-top">
                <span className="side-icon">💬</span>
                <h3>How can we help?</h3>
              </div>
              <ul>
                <li>App feedback & feature requests</li>
                <li>Bug reports & technical issues</li>
                <li>Partnership & press inquiries</li>
                <li>Account & billing questions</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
